import { render } from "./JoinMember.vue?vue&type=template&id=3506988a&ts=true"
import script from "./JoinMember.vue?vue&type=script&lang=ts"
export * from "./JoinMember.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\JSD\\03. 사이트\\JSD_SITE\\clientapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__